var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurrency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4108_5230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M322.944 279.371V203.929H396.073L235.894 0L59.7656 203.929H131.406L243.985 362.676C256.684 324.625 285.826 294.029 322.944 279.371Z",
    fill: "#4F46E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.167 410.781H209.438V511.996H288.882C258.639 488.184 238.754 451.789 237.167 410.781Z",
    fill: "#4F46E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9062 381.782H74.4513V511.997H131.406H180.437V381.782H222.215L131.48 252.922L32.9062 381.782Z",
    fill: "#4F46E5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.571 298.961C313.836 298.961 266.051 346.746 266.051 405.481C266.051 464.216 313.836 512.001 372.571 512.001C431.306 512.001 479.091 464.216 479.091 405.481C479.091 346.746 431.306 298.961 372.571 298.961ZM360.267 454.238L320.545 414.516L341.66 393.402L360.267 412.009L403.483 368.794L424.597 389.909L360.267 454.238Z",
    fill: "#4F46E5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4108_5230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 512,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrency);
export default __webpack_public_path__ + "static/media/currency.20a647523a655c62b9bf946086476474.svg";
export { ForwardRef as ReactComponent };